module.exports = __webpack_public_path__ + "img/logo-light.a768f0d4.png";